import HorizontalScrolling from "./horizontal-scrolling/main";
jQuery(document).ready(function () {
    var table = document.querySelector('.wp-list-table');
    if (table) {
        var MainModule_1 = new HorizontalScrolling(table);
        jQuery('#acp_overflow_list_screen_table-yes').on('click', function () {
            if (jQuery(this).is(':checked')) {
                MainModule_1.enable();
                MainModule_1.store();
            }
            else {
                MainModule_1.disable();
                MainModule_1.store();
            }
        });
        AdminColumns.HorizontalScrolling = MainModule_1;
    }
});
